<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Rides</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Rides
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Rides</h4>
                </div>

                <div class="card-body">
<!--                    <form class="row g-3" @submit.prevent="searchTrips">-->
<!--                        <div class="form-group col-md-4">-->
<!--                            <input type="text" v-model="searchTrip.name" class="form-control"-->
<!--                                   placeholder="Name">-->
<!--                        </div>-->
<!--                        <div class="form-group col-md-4">-->
<!--                            <input type="text" v-model="searchTrip.email" class="form-control"-->
<!--                                   placeholder="Email">-->
<!--                        </div>-->
<!--                        <div class="form-group col-md-4">-->
<!--                            <input type="text" v-model="searchTrip.phone_number" class="form-control"-->
<!--                                   placeholder="Phone Number">-->
<!--                        </div>-->
<!--                        <div class="form-group col-md-4">-->
<!--                            <input type="text" v-model="searchTrip.company" class="form-control"-->
<!--                                   placeholder="Company Name">-->
<!--                        </div>-->
<!--                        <div class="form-group col-md-4 me-md-5">-->
<!--                            <date-picker v-model="searchTrip.dateJoined" type="date" placeholder="Date joined"-->
<!--                                         valueType="format" range></date-picker>-->
<!--                        </div> -->
<!--                        <div class="col-md-6">-->
<!--                            <button type="submit" class="btn btn-primary me-1">Search</button>-->
<!--                            <button type="button" @click="clearFilter" class="btn btn-primary me-1">Clear-->
<!--                                filter-->
<!--                            </button>-->
<!--                            <button type="button" @click="exportToCSV"-->
<!--                                    class="btn btn-secondary me-1">Export To CSV-->
<!--                            </button>-->
<!--                        </div>-->
<!--                    </form>-->

                    <div class="search-container pb-2">
                        <form @submit.prevent="applyFilter()">
                            <div class="row">
                                <div class="col-md-3 d-flex align-items-center">
                                    <input id="search-term" type="text"
                                        class="table-search form-control form-control-sm"
                                        placeholder="🔍 Search this table (Pickup, Drop Address)"
                                        v-model="searchTerm"
                                        @keyup="paginatedData"
                                    >
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="order-start-date">Insurance Type</label>
                                        <select class="form-control form-control-sm" v-model="filter.insurance_type">
                                            <option value="">All</option>
                                            <option value="insured">Insured</option>
                                            <option value="uninsured">Uninsured</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="order-start-date">Start Date</label>
                                        <input id="order-start-date" type="date" class="form-control form-control-sm" v-model="filter.start_date">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label for="order-end-date">End Date</label>
                                        <input id="order-end-date" type="date" class="form-control form-control-sm" v-model="filter.end_date">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>&nbsp;</label><br/>
                                        <button type="submit" class="btn btn-sm btn-primary glow mb-1 mb-sm-0" :disabled="isLoadingFilter">
                                            Apply Filter
                                            <i class="fa fa-spinner spinner" v-if="isLoadingFilter"></i>
                                        </button>
                                        <button type="reset" @click="resetFilter" class="btn btn-sm btn-warning glow mb-1 mb-sm-0">
                                            Reset Filter
                                        </button>
                                    </div>
                                </div>


<!--                            <div class="col-lg-3 col-md-4 col-sm-6 d-flex">-->
<!--                                <download-excel type="csv" :data="admins" :export-fields="exportFields">-->
<!--                                    <a href="#" class="export-link"><i class="fas fa-file-csv"></i> export to csv</a>-->
<!--                                    | &nbsp;-->
<!--                                </download-excel>-->
<!--                                <download-excel :data="admins" :fields="exportFields">-->
<!--                                    <a href="#" class="export-link text-warning"><i class="fa fa-file-excel-o"></i>-->
<!--                                        export to excel-->
<!--                                    </a>-->
<!--                                </download-excel>-->
<!--                            </div>-->
                            </div>
                        </form>
                    </div>

                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allTrips"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'id'">
                                <a :href="route('admin.trips.show', props.row.id)">{{ props.row.id }}</a>
                            </span>
                            <span v-else-if="props.column.label === 'Name'">
                               <a :href="route('admin.trips.show', props.row.id)">{{
                                       props.row.first_name + ' ' + props.row.last_name
                                   }}</a>
                            </span>
                            <span v-else-if="props.column.field === 'pickup_address'">
                                {{ truncateText(props.row.pickup_address) }}
                            </span>
                            <span v-else-if="props.column.field === 'drop_address'">
                                {{ truncateText(props.row.drop_address) }}
                            </span>
                            <span v-else-if="props.column.field === 'start_time'">
                                {{ formatDateTime(props.row.start_time) }}
                            </span>
                            <span v-else-if="props.column.field === 'end_time'">
                                {{ formatDateTime(props.row.end_time) }}
                            </span>
                            <span v-else-if="props.column.field === 'status'"
                                  :class="'badge-glow badge badge-' + statusClass(props.row.status)"
                            >
                                {{ props.row.status }}
                            </span>
                            <span v-else-if="props.column.field === 'action'">
                                <a :href="route('admin.trips.show', props.row.id)"><i class="feather icon-eye"></i> View</a>
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import th from "vue2-datepicker/locale/es/th";

export default {
    metaInfo: {title: 'Rides'},
    props: ['trips', 'type'],
    name: "TripIndex",
    layout: Layout,

    data: () => ({
        filter: {
            start_date: '',
            end_date: '',
            insurance_type: ''
        },
        isLoadingFilter: false,
        allTrips: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Ride Id', field: 'id'},
            {label: 'Pickup Address', field: 'pickup_address'},
            {label: 'Drop Address', field: 'drop_address'},
            {label: 'Ride Start time', field: 'start_time'},
            {label: 'Ride End time', field: 'end_time'},
            {label: 'Price', field: 'price'},
            {label: 'Status', field: 'status'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
        searchTerm: '',
    }),
    created() {
        this.allTrips = this.trips.data
        this.totalRecords = this.trips.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            try {
                let url = route('admin.trips.index') +
                    `?type=${this.type}&q=${this.searchTerm}&page=${this.serverParams.page}&perPage=${this.serverParams.perPage}&start_date=${this.filter.start_date}&end_date=${this.filter.end_date}&insurance_type=${this.filter.insurance_type}`;

                let {data: {data: {trips}}} = await axios.get(url);

                this.totalRecords = trips.total;
                this.paginationOptions.perPage = trips.per_page;
                this.allTrips = trips.data
            } catch (e) {
                console.log(e);
            }
        },

        async applyFilter() {
            this.isLoadingFilter = true;
            this.tableDataLoading = true;

            this.paginatedData();

            this.isLoadingFilter = false;
            this.tableDataLoading = false;
        },

        async resetFilter() {
            this.filter = {
                start_date: '',
                end_date: '',
                insurabce_type: ''
            }
            this.serverParams= {
                page: 1,
                perPage: 10
            }
            this.searchTerm = ""
            this.paginatedData();
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },
        formatDateTime(value) {
            if (! value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        statusClass(value) {
            if (value === 'pending') {
                return "warning";
            } else if (value === 'accepted' || value === 'in_progress' || value === 'picked_up' || value === 'in_transit')
            {
                return "success";
            } else if (value === 'completed')
            {
                return "primary";
            } else {
                return "danger";
            }
        },
        truncateWords(text, wordLimit = 3) {
            if (! text) return '';

            const words = text.trim().split(/\s+/);

            return words.length > wordLimit
                ? words.slice(0, wordLimit).join(' ') + '...'
                : text;
        },
        truncateText(text, length = 30) {
            return text?.length > length ? text.slice(0, length) + '...' : text;
        }
    }
}
</script>
